import { useEffect, useSyncExternalStore } from "react";

import { client } from "@/config/client";
import { useT } from "@/shared/i18n/useT";

/* The current page's own title ("UNIT-014", "Sara Adel"), shared with the header breadcrumb. */
let pageTitle: string | undefined;
const listeners = new Set<() => void>();

function setPageTitle(title: string | undefined) {
  if (title === pageTitle) return;
  pageTitle = title;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** The title the current page gave itself, if any. */
export function usePageTitle(): string | undefined {
  return useSyncExternalStore(subscribe, () => pageTitle);
}

/** Name the browser tab after the page: "Units · Demo Realty — 404 Estate". */
export function useDocumentTitle(title: string | undefined) {
  const t = useT();
  const appName = t("app.name");

  useEffect(() => {
    const suffix = `${client.shortName} — ${appName}`;
    document.title = title ? `${title} · ${suffix}` : suffix;
    setPageTitle(title);
    return () => {
      setPageTitle(undefined);
    };
  }, [title, appName]);
}
